import { useHqScreenEvent } from './analytics';
import { HQ_NAME } from './config';
import { GUIDES, GUIDE_GROUPS } from './guides';
import { HqLayout } from './layout';
import { HqGuideCard, HqHarborBand, HqKicker } from './ui';

export function GuidesIndexPage() {
  useHqScreenEvent('HQ Guides Screen');

  return (
    <HqLayout
      title={`Coparent guides: ${HQ_NAME}`}
      description='Practical guides for the first week after you separate, proposing a schedule, splitting expenses, writing messages, documenting exchanges, and court-named apps. Not legal advice.'
      path='/guides'
    >
      <HqKicker>Guides</HqKicker>
      <h1 className='mt-2 font-hq text-4xl font-medium tracking-tight sm:text-5xl'>
        A small library, not a blog
      </h1>
      <p className='mt-4 max-w-2xl text-lg leading-relaxed text-hq-muted'>
        Each guide is a few minutes and ends with a checklist you can email to yourself. None of
        this is legal advice.
      </p>

      <div className='mt-12 space-y-12'>
        {GUIDE_GROUPS.map((group) => {
          const guides = GUIDES.filter((guide) => guide.group === group.id);
          return (
            <section key={group.id}>
              <h2 className='font-hq text-2xl font-medium tracking-tight text-hq-ink'>{group.label}</h2>
              <ul className='mt-5 grid gap-4 sm:grid-cols-2 lg:grid-cols-3'>
                {guides.map((guide) => (
                  <li key={guide.slug}>
                    <HqGuideCard
                      href={`/guides/${guide.slug}`}
                      title={guide.title}
                      outcome={guide.outcome}
                      readMinutes={guide.readMinutes}
                    />
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
      </div>

      <div className='mt-14'>
        <HqHarborBand location='guides-index-band' />
      </div>
    </HqLayout>
  );
}
